import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const year = new Date().getFullYear();

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-14 md:px-6 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-eye-line text-xl"></i>
            </span>
            <span className="font-heading text-xl font-bold text-background-50">美日吃瓜</span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200">
            一个专注围观美日文化冲突的内容频道。争议言论、网络骂战、价值观碰撞、政治正确与翻车现场，我们把两边的话都摆上桌，再一起看这段热闹里到底发生了什么。
          </p>
          <div className="mt-6 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100">
              <i className="ri-mail-line"></i>
            </span>
            <div className="text-sm">
              <p className="text-background-300">联系与投稿</p>
              <a href="mailto:contact@meirichigua.com" className="text-background-50 underline-offset-4 hover:underline">
                contact@meirichigua.com
              </a>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="font-heading text-base font-semibold text-background-50">栏目导航</h4>
          <ul className="mt-4 space-y-3 text-sm">
            {categories.map((cat) => (
              <li key={cat.slug}>
                <Link to={`/category/${cat.slug}`} className="text-background-200 transition-colors hover:text-accent-300">
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-heading text-base font-semibold text-background-50">站内导航</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Link to="/" className="text-background-200 transition-colors hover:text-accent-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/topics" className="text-background-200 transition-colors hover:text-accent-300">
                话题总览
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-200 transition-colors hover:text-accent-300">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h4 className="font-heading text-base font-semibold text-background-50">阅读提示</h4>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            站内内容为文化现象观察与观点整理，欢迎在注明来源的前提下引用与讨论。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-background-300 sm:flex-row md:px-6">
          <p>© {year} 美日吃瓜 · 内容仅作跨文化观察与讨论使用</p>
          <p className="flex items-center gap-2">
            <i className="ri-earth-line"></i>
            先理解，再评判
          </p>
        </div>
      </div>
    </footer>
  );
}